/* =============================================================================
   Wove — interaction layer
   Vanilla replacements for every behaviour the original site drove from React:
   header scroll state, navigation drawers, search, accordions, video modals,
   carousels, product galleries, shop filters and product configurators.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------- helpers -- */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function swapClass(el, from, to) {
    if (!el) return;
    if (from) el.classList.remove(from);
    if (to) el.classList.add(to);
  }

  var scrollLock = {
    depth: 0,
    lock: function () {
      if (this.depth++ === 0) {
        document.body.style.overflowY = 'hidden';
        document.body.style.height = '100%';
      }
    },
    unlock: function () {
      if (--this.depth <= 0) {
        this.depth = 0;
        document.body.style.overflowY = 'auto';
        document.body.style.height = 'auto';
      }
    }
  };

  /* -------------------------------------------------------------- header -- */
  /* Above the fold the header is transparent over the hero; as soon as the page
     scrolls it turns into the solid sand-coloured bar. On non-hero pages it is solid immediately. */
  function initHeader() {
    var header = $('#header');
    var responsive = $('.site-header__responsive-header');
    var items = $$('.site-header__list-item');
    var login = $('.site-header__login');
    if (!header && !responsive) return;

    var isTransparentAllowed = document.body.getAttribute('data-transparent-header') === 'true';

    function apply() {
      var scrolled = !isTransparentAllowed || window.scrollY > 0;
      if (header) header.classList.toggle('site-header__header-mod', scrolled);
      if (responsive) responsive.classList.toggle('site-header__responsive-header-mod', scrolled);
      items.forEach(function (li) {
        li.classList.toggle('site-header__list-item-mod', scrolled);
        li.classList.toggle('over', !scrolled);
      });
      if (login) login.classList.toggle('site-header__list-item-mod', scrolled);
    }

    apply();
    if (isTransparentAllowed) {
      window.addEventListener('scroll', apply, { passive: true });
    }
  }

  /* Desktop dropdowns are hover-driven in CSS; this adds keyboard parity. */
  function initHeaderDropdowns() {
    var menuItems = $$('.site-header__list-item');

    menuItems.forEach(function (li) {
      var dropdown = $('.site-header__dropdown', li);
      var trigger = $('.site-header__navli', li);
      if (!dropdown || !trigger) return;

      function open(state) {
        if (state) {
          menuItems.forEach(function (otherItem) {
            if (otherItem === li) return;
            var otherDropdown = $('.site-header__dropdown', otherItem);
            var otherTrigger = $('.site-header__navli', otherItem);
            otherItem.classList.remove('site-header__dropdown-open');
            if (otherDropdown) {
              otherDropdown.style.visibility = '';
              otherDropdown.style.opacity = '';
            }
            if (otherTrigger && otherTrigger.hasAttribute('aria-expanded')) {
              otherTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        }

        li.classList.toggle('site-header__dropdown-open', state);
        dropdown.style.visibility = state ? 'visible' : '';
        dropdown.style.opacity = state ? '1' : '';
        trigger.setAttribute('aria-expanded', String(state));
      }

      on(trigger, 'click', function (e) {
        if (trigger.getAttribute('href') === '#') {
          e.preventDefault();
          open(trigger.getAttribute('aria-expanded') !== 'true');
        }
      });
      on(li, 'focusin', function (e) {
        if (e.target !== trigger) open(true);
      });
      on(li, 'focusout', function () {
        window.setTimeout(function () { if (!li.contains(document.activeElement)) open(false); }, 0);
      });
      on(li, 'mouseleave', function () { open(false); });
      on(li, 'keydown', function (e) { if (e.key === 'Escape') { open(false); trigger.focus(); } });
      $$('a[href]', dropdown).forEach(function (link) {
        on(link, 'click', function () { open(false); });
      });
      on(document, 'click', function (e) {
        if (!li.contains(e.target)) open(false);
      });
    });
  }

  /* --------------------------------------------------------- mobile menu -- */
  function initMobileMenu() {
    var panel = $('.mobile-menu__header-responsive');
    if (!panel) return;
    var openBtn = $('.site-header__responsive-header .site-header__menu-button');
    var closeBtn = $('.mobile-menu__first-section-close');

    function open() {
      panel.classList.remove('mobile-menu__hide');
      swapClass(panel, 'mobile-menu__leave-animation', 'mobile-menu__enter-animation');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      scrollLock.lock();
    }
    function close() {
      swapClass(panel, 'mobile-menu__enter-animation', 'mobile-menu__leave-animation');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      scrollLock.unlock();
      window.setTimeout(function () {
        if (panel.classList.contains('mobile-menu__leave-animation')) panel.classList.add('mobile-menu__hide');
      }, 500);
    }

    on(openBtn, 'click', open);
    on(closeBtn, 'click', close);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && !panel.classList.contains('mobile-menu__hide')) close();
    });
    // navigating away should not leave the body locked
    $$('a', panel).forEach(function (a) { on(a, 'click', function () { scrollLock.unlock(); }); });
  }

  /* -------------------------------------------------------- search panel -- */
  function initSearchDrawer() {
    var drawer = $('#search-drawer');
    if (!drawer) return;
    var overlay = $('.search-drawer__container');
    var openBtn = $('#header .site-header__search') || $('#header .site-header__menu-button') || $('.site-header__search');
    var closeBtn = $('.search-drawer__close-button');
    var input = $('.search-drawer__search-input', drawer);
    var submitButton = $('.search-drawer__svg-icon-container', drawer);

    function submitSearch() {
      var query = input ? input.value.trim() : '';
      if (query) window.location.assign('/search?q=' + encodeURIComponent(query));
    }

    function open() {
      drawer.classList.add('search-drawer__open-search-drawer');
      if (overlay) overlay.classList.add('search-drawer__open-container');
      if (input) { input.removeAttribute('tabindex'); window.setTimeout(function () { input.focus(); }, 60); }
    }
    function close() {
      drawer.classList.remove('search-drawer__open-search-drawer');
      if (overlay) overlay.classList.remove('search-drawer__open-container');
    }

    on(openBtn, 'click', open);
    on($('.mobile-menu__search-text'), 'click', open);
    on(closeBtn, 'click', close);
    on(submitButton, 'click', submitSearch);
    on(input, 'keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        submitSearch();
      }
    });
    on(overlay, 'click', close);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('search-drawer__open-search-drawer')) close();
    });
  }

  /* ------------------------------------------------------- mobile drawer -- */
  function initNavDrawer() {
    var drawer = $('#modal-navigation-drawer');
    if (!drawer) return;
    var overlay = $('.nav-drawer__container');
    var close = $('.nav-drawer__close-mobile', drawer);

    function hide() {
      drawer.classList.remove('nav-drawer__open-modal-drawer');
      if (overlay) overlay.classList.remove('nav-drawer__open-container');
      scrollLock.unlock();
    }
    on(close, 'click', hide);
    on(overlay, 'click', hide);
  }

  /* ----------------------------------------------------------- accordion -- */
  /* Two visual variants exist; both use the same header/body/indicator trio. */
  function splitLegacyFaqColumns() {
    $$('.faq-accordion__questions').forEach(function (questions) {
      if ($('.faq-accordion__column', questions)) return;

      var items = $$('.faq-accordion__expand-container-2', questions).filter(function (item) {
        return item.parentNode === questions;
      });
      if (items.length < 2) return;

      var columns = [document.createElement('div'), document.createElement('div')];
      columns.forEach(function (column) {
        column.className = 'faq-accordion__column';
      });

      items.forEach(function (item, index) {
        item.style.setProperty('--faq-page-order', String(index + 1));
        columns[index % 2].appendChild(item);
      });

      columns.forEach(function (column) {
        questions.appendChild(column);
      });
    });
  }

  function initAccordions() {
    var variants = [
      { header: 'faq-accordion__expand-header', title: 'faq-accordion__expand-title-text', open: 'faq-accordion__expand-title-text-open', ind: 'faq-accordion__expand-indicator', close: 'faq-accordion__closeexpand', collapsed: 'faq-accordion__collapse-content', expanded: 'faq-accordion__expanded-content' },
      { header: 'faq-accordion__expand-header-2', title: 'faq-accordion__expand-title-text-2', open: 'faq-accordion__expand-title-text-open-2', ind: 'faq-accordion__expand-indicator-2', close: 'faq-accordion__closeexpand-2', collapsed: 'faq-accordion__collapse-content-2', expanded: 'faq-accordion__expanded-content-2' }
    ];

    variants.forEach(function (v) {
      $$('.' + v.header).forEach(function (btn) {
        var container = btn.parentNode;
        var title = $('.' + v.title, btn) || $('.' + v.open, btn);
        var indicator = $('.' + v.ind, btn) || $('.' + v.close, btn);
        var body = $('.' + v.collapsed, container) || $('.' + v.expanded, container);
        if (!body) return;

        on(btn, 'click', function () {
          var isOpen = body.classList.contains(v.expanded);
          swapClass(body, isOpen ? v.expanded : v.collapsed, isOpen ? v.collapsed : v.expanded);
          if (title) swapClass(title, isOpen ? v.open : v.title, isOpen ? v.title : v.open);
          if (indicator) swapClass(indicator, isOpen ? v.close : v.ind, isOpen ? v.ind : v.close);
          btn.setAttribute('aria-expanded', String(!isOpen));
          var label = btn.getAttribute('aria-label');
          if (label) btn.setAttribute('aria-label', (isOpen ? 'Expand: ' : 'Collapse: ') + label.replace(/^(Expand|Collapse): /, ''));
        });
      });
    });
  }

  /* --------------------------------------------------------- video modal -- */
  function initVideoModals() {
    var pairs = [
      { modal: 'video-banner__modalvideo', open: 'video-banner__modalvideoopen', close: 'video-banner__close' },
      { modal: 'craft-workshop__modalvideo', open: 'craft-workshop__modalvideoopen', close: 'craft-workshop__close' }
    ];

    pairs.forEach(function (p) {
      var modal = $('.' + p.modal) || $('.' + p.open);
      if (!modal) return;
      var triggers = $$('.video-banner__play-button, .video-banner__responsive-play, .craft-workshop__play-button, .craft-workshop__play-button-mobile, .ring-path__play-button');
      var closeBtn = $('.' + p.close, modal);

      function open() {
        swapClass(modal, p.modal, p.open);
        scrollLock.lock();
        var v = $('video', modal);
        if (v) { try { v.currentTime = 0; v.play(); } catch (e) { /* autoplay may be blocked */ } }
      }
      function close() {
        swapClass(modal, p.open, p.modal);
        scrollLock.unlock();
        var v = $('video', modal);
        if (v) v.pause();
      }

      triggers.forEach(function (t) { on(t, 'click', open); });
      on(closeBtn, 'click', close);
      on(modal, 'click', function (e) { if (e.target === modal) close(); });
      on(document, 'keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains(p.open)) close(); });
    });
  }

  /* -------------------------------------------------------------- slider -- */
  /* Re-implementation of the carousel the original built with keen-slider:
     slides keep a static `index * spacing` offset and the whole strip is
     shifted by the current scroll amount, clamped to the content width. */
  function Slider(root, opts) {
    this.root = root;
    this.slides = $$('.keen-slider__slide', root);
    if (!this.slides.length) return;
    root.__slider = this;
    this.spacing = opts && opts.spacing != null ? opts.spacing : this.detectSpacing();
    this.offset = 0;
    this.index = 0;
    root.style.touchAction = 'pan-y'; // let the browser own vertical scroll; JS only owns horizontal drag
    this.bindDrag();
    this.layout();
    window.addEventListener('resize', this.layout.bind(this));
    window.addEventListener('load', this.layout.bind(this)); // recompute once images report their real size
  }

  Slider.prototype.detectSpacing = function () {
    var m = (this.slides[1] && this.slides[1].style.transform || '').match(/translate3d\((-?[\d.]+)px/);
    return m ? Math.round(parseFloat(m[1])) : 0;
  };

  Slider.prototype.step = function () {
    var w = this.slides[0].getBoundingClientRect().width;
    return w + this.spacing;
  };

  Slider.prototype.maxOffset = function () {
    var w = this.slides[0].getBoundingClientRect().width;
    var content = this.slides.length * w + (this.slides.length - 1) * this.spacing;
    return Math.max(0, content - this.root.getBoundingClientRect().width);
  };

  Slider.prototype.layout = function (animate) {
    var max = this.maxOffset();
    if (this.offset > max) this.offset = max;
    if (this.offset < 0) this.offset = 0;
    var self = this;
    this.slides.forEach(function (s, i) {
      s.style.transition = animate === false ? 'none' : 'transform .5s cubic-bezier(.25,.75,.5,1)';
      s.style.transform = 'translate3d(' + (i * self.spacing - self.offset) + 'px, 0px, 0px)';
    });
    var stepSize = this.step();
    this.index = stepSize > 0 ? Math.round(this.offset / stepSize) : 0;
    if (this.onChange) this.onChange(this.index, this.offset >= max - 1, this.offset <= 1);
  };

  Slider.prototype.moveBy = function (delta) {
    this.offset += delta * this.step();
    this.layout();
  };

  Slider.prototype.moveTo = function (i) {
    this.offset = i * this.step();
    this.layout();
  };

  Slider.prototype.bindDrag = function () {
    var self = this;
    var startX = 0, startY = 0, startOffset = 0;
    var tracking = false;   // pointer is down, direction not yet decided
    var dragging = false;   // confirmed horizontal drag, safe to preventDefault
    var LOCK_THRESHOLD = 8; // px of movement before committing to a direction

    function down(x, y) {
      tracking = true;
      dragging = false;
      startX = x;
      startY = y;
      startOffset = self.offset;
    }
    function move(x, y, e) {
      if (!tracking) return;
      var dx = x - startX;
      var dy = y - startY;
      if (!dragging) {
        if (Math.abs(dx) < LOCK_THRESHOLD && Math.abs(dy) < LOCK_THRESHOLD) return; // not decided yet
        if (Math.abs(dy) > Math.abs(dx)) { tracking = false; return; } // vertical swipe: let the page scroll
        dragging = true; // horizontal swipe confirmed
      }
      if (e && e.cancelable) e.preventDefault();
      self.offset = startOffset - dx;
      self.layout(false);
    }
    function up() {
      if (dragging) {
        var s = self.step();
        if (s > 0) self.offset = Math.round(self.offset / s) * s;
        self.layout();
      }
      tracking = false;
      dragging = false;
    }

    on(this.root, 'pointerdown', function (e) { down(e.clientX, e.clientY); });
    on(window, 'pointermove', function (e) { move(e.clientX, e.clientY, e); }, { passive: false });
    on(window, 'pointerup', up);
    on(window, 'pointercancel', up);
    on(this.root, 'dragstart', function (e) { e.preventDefault(); });
  };

  function initSliders() {
    /* "Choose your path" carousel with white arrows. */
    $$('.ring-path__slider').forEach(function (root) {
      var wrap = root.closest('.ring-path__slider-container') || root.parentNode;
      var left = $('.ring-path__arrow-left', wrap) || $('.ring-path__arrow-left');
      var right = $('.ring-path__arrow-right', wrap) || $('.ring-path__arrow-right');
      var slider = new Slider(root);
      if (!slider.slides || !slider.slides.length) return;

      slider.onChange = function (i, atEnd, atStart) {
        if (left) left.classList.toggle('ring-path__disabled', atStart);
        if (right) right.classList.toggle('ring-path__disabled', atEnd);
      };
      slider.layout();
      on(left, 'click', function () { slider.moveBy(-1); });
      on(right, 'click', function () { slider.moveBy(1); });
    });

    /* Product image carousel (mobile) with dots. */
    $$('.product-gallery__grid-gallery .keen-slider, .product-gallery__grid-gallery2 .keen-slider').forEach(function (root) {
      var slider = new Slider(root, { spacing: 0 });
      if (!slider.slides || !slider.slides.length) return;
      var wrap = root.closest('.product-gallery__navigation-wrapper') || root.parentNode;
      var dots = $$('.product-gallery__dot', wrap);
      var arrowWrappers = $$('.product-gallery__arrow-wrapper', wrap);
      var prev = $('.product-gallery__arrowback', wrap) || arrowWrappers[0];
      var next = $('.product-gallery__arrowfoward', wrap) || arrowWrappers[1];

      slider.onChange = function (i, atEnd, atStart) {
        dots.forEach(function (d, di) { d.classList.toggle('product-gallery__active', di === i); });
        if (prev) {
          prev.classList.toggle('product-gallery__disabled', atStart);
          var prevIcon = $('svg', prev);
          if (prevIcon) prevIcon.classList.toggle('product-gallery__arrow-disabled', atStart);
          prev.setAttribute('aria-disabled', String(atStart));
        }
        if (next) {
          next.classList.toggle('product-gallery__disabled', atEnd);
          var nextIcon = $('svg', next);
          if (nextIcon) nextIcon.classList.toggle('product-gallery__arrow-disabled', atEnd);
          next.setAttribute('aria-disabled', String(atEnd));
        }
      };
      slider.layout();
      slider.onChange(slider.index || 0, slider.index >= slider.slides.length - 1, slider.index <= 0);
      dots.forEach(function (d, di) { on(d, 'click', function () { slider.moveTo(di); }); });
      on(prev, 'click', function () { if (!prev.classList.contains('product-gallery__disabled')) slider.moveBy(-1); });
      on(next, 'click', function () { if (!next.classList.contains('product-gallery__disabled')) slider.moveBy(1); });
    });
  }

  /* ----------------------------------------------------- product gallery -- */
  function initProductGallery() {
    var modal = $('.product-gallery__modalimage') || $('.product-gallery__modalimageopen');
    if (!modal) return;
    var close = $('.product-gallery__close', modal);
    var modalImage = $('.product-gallery__modal-content', modal);
    var lastTrigger = null;

    function show(e) {
      var source = e && e.currentTarget ? ($('img', e.currentTarget) || e.currentTarget) : null;
      if (modalImage && source && source.src) {
        modalImage.src = source.currentSrc || source.src;
        modalImage.alt = source.alt || '';
      }
      lastTrigger = e && e.currentTarget ? e.currentTarget : null;
      swapClass(modal, 'product-gallery__modalimage', 'product-gallery__modalimageopen');
      modal.setAttribute('aria-hidden', 'false');
      modal.scrollTop = 0;
      scrollLock.lock();
      if (close) close.focus();
    }
    function hide() {
      swapClass(modal, 'product-gallery__modalimageopen', 'product-gallery__modalimage');
      modal.setAttribute('aria-hidden', 'true');
      scrollLock.unlock();
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    $$('.product-gallery__grid-gallery .media__main2 img').forEach(function (t) { on(t, 'click', show); });
    on(close, 'click', hide);
    on(modal, 'click', function (e) { if (e.target === modal) hide(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('product-gallery__modalimageopen')) hide(); });
  }

  /* --------------------------------------------------------- shop filter -- */
  function initShopFilters() {
    if ($('wove-collection-facets')) return;
    var filterContainer = $('#CollectionProductGrid') || document;

    function desktopDrop(li) {
      return $('.shop-filters__diamond-drop, .shop-filters__style-drop, .shop-filters__metal-drop', li);
    }

    function closeDesktopDrop(li) {
      var drop = desktopDrop(li);
      li.setAttribute('aria-expanded', 'false');
      li.classList.remove('shop-filters__open');
      if (!drop) return;
      if (drop.classList.contains('shop-filters__diamond-drop')) drop.classList.add('shop-filters__active-diamond');
      if (drop.classList.contains('shop-filters__style-drop')) drop.classList.add('shop-filters__active-style');
      if (drop.classList.contains('shop-filters__metal-drop')) drop.classList.add('shop-filters__active-metal');
    }

    /* Desktop dropdown filters toggle. */
    $$('.shop-filters__diamond-shape, .shop-filters__stylesring, .shop-filters__metal').forEach(function (li) {
      var drop = desktopDrop(li);
      on(li, 'click', function (e) {
        if (e.target.closest('.shop-filters__diamond-images, .shop-filters__style-images, .shop-filters__metal-images, .shop-filters__diamond-drop, .shop-filters__style-drop, .shop-filters__metal-drop')) return;
        var isOpen = li.classList.contains('shop-filters__open');
        $$('.shop-filters__diamond-shape, .shop-filters__stylesring, .shop-filters__metal').forEach(function (other) {
          closeDesktopDrop(other);
        });
        if (!isOpen) {
          li.setAttribute('aria-expanded', 'true');
          li.classList.add('shop-filters__open');
          if (drop) {
            drop.classList.remove('shop-filters__active-diamond', 'shop-filters__active-style', 'shop-filters__active-metal');
          }
        }
      });
      if (drop) on(drop, 'click', function (e) { e.stopPropagation(); });
    });

    // Close dropdowns when clicking outside
    on(document, 'click', function (e) {
      if (!e.target.closest('.shop-filters__diamond-shape, .shop-filters__stylesring, .shop-filters__metal')) {
        $$('.shop-filters__diamond-shape, .shop-filters__stylesring, .shop-filters__metal').forEach(function (li) {
          closeDesktopDrop(li);
        });
      }
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') {
        $$('.shop-filters__diamond-shape, .shop-filters__stylesring, .shop-filters__metal').forEach(function (li) {
          closeDesktopDrop(li);
        });
      }
    });

    /* Selecting a swatch toggles it and re-filters the grid. */
    $$('[class*="__diamond-images"], [class*="__style-images"], [class*="__metal-images"]', filterContainer).forEach(function (opt) {
      on(opt, 'click', function () {
        var checked = opt.getAttribute('aria-checked') === 'true';
        opt.setAttribute('aria-checked', String(!checked));
        opt.classList.toggle('is-selected', !checked);
        applyFilters();
      });
    });

    /* Desktop and Mobile Reset buttons */
    $$('.shop-filter-bar__button-reset, .shop-filters__button-reset, .product-grid__button-reset').forEach(function (btn) {
      on(btn, 'click', function () {
        $$('[aria-checked="true"]', filterContainer).forEach(function (o) {
          o.setAttribute('aria-checked', 'false');
          o.classList.remove('is-selected');
        });
        applyFilters();
      });
    });

    /* Desktop Sort list items */
    $$('.shop-filters__ul-sort li').forEach(function (item) {
      on(item, 'click', function () {
        $$('.shop-filters__ul-sort li').forEach(function (o) { o.classList.remove('active'); });
        item.classList.add('active');
        sortGrid(item.textContent.trim());
      });
    });

    var desktopSortButton = $('.shop-filters__button-sort');
    var desktopSortDrop = $('.shop-filters__sort-drop');
    on(desktopSortButton, 'click', function (e) {
      e.stopPropagation();
      if (desktopSortDrop) desktopSortDrop.classList.toggle('shop-filters__active-sort');
    });

    /* Mobile filter / sort sheet. */
    var filterSheet = $('[data-mobile-sheet="filters"]');
    var sortSheet = $('[data-mobile-sheet="sort"]');
    function setupSheet(sheet, trigger) {
      if (!sheet) return;
      var openSheet = function () { swapClass(sheet, 'shop-filter-bar__modalimage', 'shop-filter-bar__modalimageopen'); scrollLock.lock(); };
      var closeSheet = function () { swapClass(sheet, 'shop-filter-bar__modalimageopen', 'shop-filter-bar__modalimage'); scrollLock.unlock(); };
      on(trigger, 'click', openSheet);
      on($('.shop-filter-bar__close', sheet), 'click', closeSheet);
      on($('.shop-filter-bar__button-appy', sheet), 'click', function () { applyFilters(); closeSheet(); });
      on($('.shop-filter-bar__button-appy-mobile', sheet), 'click', function () { applyFilters(); closeSheet(); });
    }
    setupSheet(filterSheet, $('.shop-filter-bar__button'));
    setupSheet(sortSheet, $('.shop-filter-bar__button-sort'));
    if (filterSheet) {
      $$('.shop-filter-bar__item', filterSheet).forEach(function (item) {
        on(item, 'click', function (e) {
          if (e.target.closest('[class*="__diamond-images"], [class*="__style-images"], [class*="__metal-images"]')) return;
          var isOpen = item.classList.toggle('shop-filter-bar__filters-open');
          var panel = $('[class*="shop-filter-bar__active-"]', item);
          if (panel) panel.style.display = isOpen ? 'block' : '';
        });
      });
    }
    if (sortSheet) {
      $$('.shop-filter-bar__item-sort', sortSheet).forEach(function (item) {
        on(item, 'click', function () {
          $$('.shop-filter-bar__item-sort', sortSheet).forEach(function (o) { o.classList.remove('shop-filter-bar__active-sort'); });
          item.classList.add('shop-filter-bar__active-sort');
          sortGrid(item.textContent.trim());
        });
      });
    }

    applyFilters();
  }

  function selectedValues() {
    var picked = { shape: [], style: [], metal: [] };
    var filterContainer = $('#CollectionProductGrid') || document;
    $$('[aria-checked="true"]', filterContainer).forEach(function (o) {
      var facet = o.getAttribute('data-facet');
      var value = (o.getAttribute('data-value') || o.textContent || '').trim().toLowerCase();
      var cls = o.className || '';
      var label = (o.getAttribute('aria-label') || '').toLowerCase();

      if (facet === 'shape' || (!facet && (/diamond/.test(cls) || /diamond shape/.test(label)))) {
        picked.shape.push(value);
      } else if (facet === 'metal' || (!facet && /metal/i.test(cls))) {
        picked.metal.push(value);
      } else if (facet === 'style' || (!facet && /style/i.test(cls))) {
        picked.style.push(value);
      }
    });
    return picked;
  }

  function applyFilters() {
    var grid = $('.product-grid__grid-container');
    if (!grid) return;
    var picked = selectedValues();
    var any = picked.shape.length || picked.style.length || picked.metal.length;
    var shown = 0;

    $$('[data-product]', grid).forEach(function (card) {
      var ok = true;
      if (any) {
        if (picked.shape.length) ok = ok && picked.shape.indexOf((card.dataset.shape || '').toLowerCase()) !== -1;
        if (picked.style.length) ok = ok && picked.style.indexOf((card.dataset.style || '').toLowerCase()) !== -1;
        if (picked.metal.length) ok = ok && picked.metal.indexOf((card.dataset.metal || '').toLowerCase()) !== -1;
      }
      card.hidden = !ok;
      if (ok) shown++;
    });

    var empty = $('.product-grid__empty');
    if (empty) empty.hidden = shown !== 0;
  }

  function sortGrid(mode) {
    var grid = $('.product-grid__grid-container');
    if (!grid) return;
    var wrap = $('.product-grid__grid-gallery', grid) || grid;
    var cards = $$('[data-product]', wrap);
    if (!cards.length) return;
    var asc = /low/i.test(mode);
    var desc = /high/i.test(mode);
    var byName = /name/i.test(mode);
    var byStyle = /style/i.test(mode);
    cards.sort(function (a, b) {
      if (byName) return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      if (byStyle) return (a.dataset.style || '').localeCompare(b.dataset.style || '');
      var pa = parseFloat(a.dataset.price || '0'), pb = parseFloat(b.dataset.price || '0');
      if (asc) return pa - pb;
      if (desc) return pb - pa;
      return parseInt(a.dataset.index || '0', 10) - parseInt(b.dataset.index || '0', 10);
    });
    cards.forEach(function (c) { wrap.appendChild(c); });
  }

  /* ------------------------------------------------- product configurator -- */
  function initConfigurator() {
    /* Metal / style / shape swatches: pick one per group and mirror the choice
       on the price line and the hero image where the markup provides one. */
    var groups = [
      { items: '.metal-picker__style-images', active: 'metal-picker__style-image-selected' },
      { items: '.metal-picker__style-types', active: 'metal-picker__active-metal' },
      { items: '.diamond-picker__diamond', active: 'diamond-picker__selected' },
      { items: '.ring-size__size-options .ring-size__unselected-size', active: 'ring-size__size-selected' }
    ];

    groups.forEach(function (g) {
      var items = $$(g.items);
      items.forEach(function (item) {
        on(item, 'click', function () {
          items.forEach(function (o) { o.classList.remove(g.active); });
          item.classList.add(g.active);
          var price = item.getAttribute('data-price');
          var out = $('.product-summary__final-price');
          if (price && out) out.textContent = price;
        });
      });
    });

    /* Engraving font picker + live preview. */
    $$('.engraving__font-select').forEach(function (opt) {
      on(opt, 'click', function () {
        $$('.engraving__font-select').forEach(function (o) { o.classList.remove('engraving__font-check-selected'); });
        opt.classList.add('engraving__font-check-selected');
      });
    });

    /* Small info modals used across the buying panel. */
    [['product-buying__modal-replica', 'product-buying__modal-replicaopen'],
     ['ring-size__modal-information', 'ring-size__modal-information-open'],
     ['engraving__modal-info', 'engraving__modal-info-open']].forEach(function (pair) {
      var modal = $('.' + pair[0]) || $('.' + pair[1]);
      if (!modal) return;
      var close = $('[class*="close"]', modal);
      $$('[class*="learn-more"], [class*="find-size"], [class*="text-guide"]').forEach(function (t) {
        on(t, 'click', function () {
          swapClass(modal, pair[0], pair[1]);
          modal.setAttribute('aria-hidden', 'false');
          scrollLock.lock();
        });
      });
      on(close, 'click', function () {
        swapClass(modal, pair[1], pair[0]);
        modal.setAttribute('aria-hidden', 'true');
        scrollLock.unlock();
      });
    });

    $$('.ring-size__table-body-size-button').forEach(function (button) {
      on(button, 'click', function () {
        var dropdown = $('#RingSizeDropdown');
        if (dropdown) {
          dropdown.value = button.getAttribute('data-size') || '';
          dropdown.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var modal = button.closest('.ring-size__modal-information');
        if (modal) {
          swapClass(modal, 'ring-size__modal-information-open', 'ring-size__modal-information');
          modal.setAttribute('aria-hidden', 'true');
          scrollLock.unlock();
        }
      });
    });
  }

  /* ------------------------------------------------ PDP Variant & Thumbnail Picker -- */
  function initPdpVariantPicker() {
    var serverRenderedPicker = $('variant-selects[data-wove-server-rendered]');
    if (serverRenderedPicker) {
      var serverProductInfo = serverRenderedPicker.closest('product-info');
      var serverSectionId = serverProductInfo ? serverProductInfo.getAttribute('data-section') : '';
      var serverVariantInput = serverProductInfo ? $('#SelectedVariantId', serverProductInfo) : $('#SelectedVariantId');
      var serverBuyBtn = serverProductInfo ? $('.product-buying__buy-button', serverProductInfo) : $('.product-buying__buy-button');

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
          var data = payload && payload.data ? payload.data : null;
          if (!data || String(data.sectionId) !== String(serverSectionId)) return;

          var variant = data.variant;
          var buttonLabel = serverBuyBtn ? $('span', serverBuyBtn) : null;
          if (serverVariantInput) serverVariantInput.value = variant ? variant.id : '';

          if (serverBuyBtn) {
            var unavailable = !variant;
            var soldOut = variant && variant.available === false;
            serverBuyBtn.disabled = unavailable || soldOut;
            serverBuyBtn.setAttribute('aria-disabled', String(unavailable || soldOut));
            if (buttonLabel) {
              buttonLabel.textContent = unavailable
                ? ((window.variantStrings && window.variantStrings.unavailable) || 'Unavailable')
                : soldOut
                  ? (serverBuyBtn.getAttribute('data-sold-out-label') || (window.variantStrings && window.variantStrings.soldOut) || 'Sold Out')
                  : (serverBuyBtn.getAttribute('data-available-label') || 'Add to Bag');
            }
          }
        });
      }

      $$('.product-gallery__thumb-item').forEach(function (thumb, idx) {
        on(thumb, 'click', function () {
          $$('.product-gallery__thumb-item').forEach(function (item) { item.classList.remove('product-gallery__thumb-active'); });
          thumb.classList.add('product-gallery__thumb-active');
          var mainSliderRoot = $('.product-gallery__grid-gallery .keen-slider');
          if (mainSliderRoot && mainSliderRoot.__slider) mainSliderRoot.__slider.moveTo(idx);
        });
      });
      return;
    }

    var variantsJsonEl = $('#ProductVariants');
    var productVariants = [];
    if (variantsJsonEl) {
      try { productVariants = JSON.parse(variantsJsonEl.textContent); } catch (e) {}
    }
    var swatches = $$('.metal-picker__swatch-option');
    var priceEl = $('#ProductPrice');
    var metalLabel = $('#SelectedMetalName');
    var variantInput = $('#SelectedVariantId');
    var diamondCards = $$('.diamond-picker__diamond');
    var diamondInput = $('#PropertyDiamondType');
    var ringSizeDropdown = $('#RingSizeDropdown');
    var ringSizeInput = $('#PropertyRingSize');
    var buyBtn = $('.product-buying__buy-button');
    var optionControls = $$('[data-option-position]');

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.moneyFormat || window.Shopify.money_format || '${{amount}}');
      }
      var dollars = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return '$' + dollars;
    }

    function resolveVariant() {
      var selectedOptions = {};
      optionControls.forEach(function (control) {
        var position = parseInt(control.getAttribute('data-option-position') || '0', 10);
        if (!position) return;
        if (control.tagName === 'SELECT') {
          selectedOptions[position] = control.value;
        } else if (control.getAttribute('aria-checked') === 'true') {
          selectedOptions[position] = control.getAttribute('data-value') || control.getAttribute('data-metal-name') || control.getAttribute('data-diamond-type') || '';
        }
      });
      var match = null;
      if (productVariants.length > 0) {
        match = productVariants.find(function (variant) {
          return Object.keys(selectedOptions).every(function (position) {
            var expected = String(selectedOptions[position] || '').trim().toLowerCase();
            var actual = String((variant.options || [])[parseInt(position, 10) - 1] || '').trim().toLowerCase();
            return expected === actual;
          });
        });
        if (!match && Object.keys(selectedOptions).length > 0) {
          if (variantInput) variantInput.value = '';
          if (buyBtn) {
            buyBtn.disabled = true;
            buyBtn.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Unavailable';
          }
          return;
        }
        if (!match && variantInput && variantInput.value) {
          match = productVariants.find(function (v) { return String(v.id) === String(variantInput.value); });
        }
      }

      if (match) {
        if (variantInput) variantInput.value = match.id;
        var formattedPrice = formatMoney(match.price);
        if (priceEl) priceEl.textContent = formattedPrice;
        var addToCartPrice = $('#AddToCartPrice');
        if (addToCartPrice) addToCartPrice.textContent = formattedPrice;

        if (buyBtn) {
          if (match.available === false) {
            buyBtn.disabled = true;
            buyBtn.textContent = buyBtn.getAttribute('data-sold-out-label') || (window.variantStrings && window.variantStrings.soldOut) || 'Sold Out';
          } else {
            buyBtn.disabled = false;
            buyBtn.textContent = buyBtn.getAttribute('data-available-label') || 'Add to Bag';
          }
        }

        if (window.history && window.history.replaceState) {
          var newUrl = window.location.pathname + '?variant=' + match.id;
          window.history.replaceState({ path: newUrl }, '', newUrl);
        }

        if (match.featured_media || match.featured_image) {
          var imgId = match.featured_media ? match.featured_media.id : (match.featured_image ? match.featured_image.id : null);
          var slides = $$('.product-gallery__grid-gallery .keen-slider__slide');
          var targetIdx = -1;
          slides.forEach(function (slide, idx) {
            var img = $('img', slide);
            if (img && ((match.featured_image && img.src.indexOf(match.featured_image) !== -1) || (imgId && img.src.indexOf(String(imgId)) !== -1))) {
              targetIdx = idx;
            }
          });
          if (targetIdx >= 0) {
            var mainSliderRoot = $('.product-gallery__grid-gallery .keen-slider');
            if (mainSliderRoot && mainSliderRoot.__slider) {
              mainSliderRoot.__slider.moveTo(targetIdx);
            }
          }
        }
      }
    }

    swatches.forEach(function (swatch) {
      on(swatch, 'click', function (e) {
        e.preventDefault();
        swatches.forEach(function (s) {
          s.classList.remove('metal-picker__style-image-selected');
          s.setAttribute('aria-checked', 'false');
        });
        swatch.classList.add('metal-picker__style-image-selected');
        swatch.setAttribute('aria-checked', 'true');

        var name = swatch.getAttribute('data-metal-name') || swatch.getAttribute('data-value') || '';
        if (metalLabel && name) metalLabel.textContent = name;
        resolveVariant();
      });
    });

    diamondCards.forEach(function (card) {
      on(card, 'click', function () {
        diamondCards.forEach(function (c) {
          c.classList.remove('diamond-picker__selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('diamond-picker__selected');
        card.setAttribute('aria-checked', 'true');
        var type = card.getAttribute('data-diamond-type') || 'Lab Grown';
        if (diamondInput) diamondInput.value = type;
        resolveVariant();
      });
    });

    if (ringSizeDropdown) {
      on(ringSizeDropdown, 'change', function () {
        if (ringSizeInput) ringSizeInput.value = ringSizeDropdown.value;
        resolveVariant();
      });
    }

    $$('.wove-variant-option').forEach(function (select) {
      on(select, 'change', resolveVariant);
    });

    // Check URL for ?variant=<id> on load
    var urlParams = new URLSearchParams(window.location.search);
    var initialVariantId = urlParams.get('variant');
    if (initialVariantId && productVariants.length > 0) {
      var initialVar = productVariants.find(function (v) { return String(v.id) === String(initialVariantId); });
      if (initialVar) {
        if (variantInput) variantInput.value = initialVar.id;
        optionControls.forEach(function (control) {
          var position = parseInt(control.getAttribute('data-option-position') || '0', 10);
          var value = String((initialVar.options || [])[position - 1] || '');
          if (!position) return;
          if (control.tagName === 'SELECT') {
            control.value = value;
          } else {
            var controlValue = control.getAttribute('data-value') || control.getAttribute('data-metal-name') || control.getAttribute('data-diamond-type') || '';
            var selected = controlValue.toLowerCase() === value.toLowerCase();
            control.setAttribute('aria-checked', String(selected));
            if (control.classList.contains('metal-picker__swatch-option')) control.classList.toggle('metal-picker__style-image-selected', selected);
            if (control.classList.contains('diamond-picker__diamond')) control.classList.toggle('diamond-picker__selected', selected);
            if (selected && control.classList.contains('metal-picker__swatch-option') && metalLabel) metalLabel.textContent = controlValue;
          }
        });
        if (ringSizeInput && ringSizeDropdown) ringSizeInput.value = ringSizeDropdown.value;
        if (diamondInput) {
          var selectedDiamondCard = $('.diamond-picker__diamond[aria-checked="true"]');
          if (selectedDiamondCard) diamondInput.value = selectedDiamondCard.getAttribute('data-diamond-type') || selectedDiamondCard.getAttribute('data-value') || '';
        }
        resolveVariant();
      }
    } else {
      resolveVariant();
    }

    // Thumbnail clicks for PDP gallery
    $$('.product-gallery__thumb-item').forEach(function (thumb, idx) {
      on(thumb, 'click', function () {
        $$('.product-gallery__thumb-item').forEach(function (t) { t.classList.remove('product-gallery__thumb-active'); });
        thumb.classList.add('product-gallery__thumb-active');
        var mainSliderRoot = $('.product-gallery__grid-gallery .keen-slider');
        if (mainSliderRoot && mainSliderRoot.__slider) {
          mainSliderRoot.__slider.moveTo(idx);
        }
      });
    });
  }

  function initForms() {
    $$('form[data-wove-inline-confirm]').forEach(function (form) {
      on(form, 'submit', function (e) {
        var invalid = false;
        $$('input[required], textarea[required]', form).forEach(function (field) {
          var bad = !field.value.trim();
          field.classList.toggle('contact-form__input-error', bad);
          if (bad) invalid = true;
        });
        if (invalid) {
          e.preventDefault();
          return;
        }
      });
    });
  }

  /* --------------------------------------------------- smooth anchor jump -- */
  function initAnchors() {
    $$('a[href^="#"]').forEach(function (a) {
      on(a, 'click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var target = document.getElementById(id.slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* --------------------------------------------------------------- boot --- */
  function boot() {
    initHeader();
    initHeaderDropdowns();
    initMobileMenu();
    initSearchDrawer();
    initNavDrawer();
    splitLegacyFaqColumns();
    initAccordions();
    initVideoModals();
    initSliders();
    initProductGallery();
    initShopFilters();
    initConfigurator();
    initPdpVariantPicker();
    initForms();
    initAnchors();
    initQuiz();
  }

  /* ---------------------------------------------------------------- quiz -- */
  function initQuiz() {
    var quizSteps = $$('.quiz-step');
    if (!quizSteps.length) return;
    
    var currentStepIdx = 0;
    var history = [];
    var answers = {};
    
    var backBtn = $('#quiz-back-btn');
    var progressBar = $('#quiz-progress-bar');
    var leftImage = $('#quiz-left-image');
    
    function updateProgress(stepNum) {
      if (progressBar) {
        var pct = (parseInt(stepNum, 10) / 5) * 100;
        progressBar.style.width = 'calc(' + pct + '% - 0px)';
      }
    }
    
    function showStep(stepId) {
      quizSteps.forEach(function(s) {
        s.classList.remove('active');
      });
      var stepEl = $('#' + stepId);
      if (stepEl) {
        stepEl.classList.add('active');
        if (leftImage && stepEl.dataset.img) {
          leftImage.src = stepEl.dataset.img;
        }
        var stepNum = stepEl.dataset.stepNum || 1;
        updateProgress(stepNum);
      }
      if (history.length > 0 && stepId !== 'step-completion') {
        backBtn.style.visibility = 'visible';
      } else {
        backBtn.style.visibility = 'hidden';
      }
    }
    
    function nextStep(currentId, answer) {
      history.push(currentId);
      var nextId = 'step-completion';
      
      if (currentId === 'step-1') {
        answers.type = answer;
        if (answer === 'Other Fine Jewelry') {
          nextId = 'step-3';
        } else {
          nextId = 'step-2';
        }
      } else if (currentId === 'step-2') {
        nextId = 'step-3';
      } else if (currentId === 'step-3') {
        if (answers.type === 'Engagement Ring') {
          nextId = 'step-4a';
        } else if (answers.type === 'Other Fine Jewelry') {
          nextId = 'step-6b';
        } else {
          nextId = 'step-5'; // Wedding Band -> skip to 5
        }
      } else if (currentId === 'step-4a') {
        nextId = 'step-4b';
      } else if (currentId === 'step-4b') {
        nextId = 'step-5';
      } else if (currentId === 'step-5') {
        if (answers.type === 'Engagement Ring') {
          nextId = 'step-6a';
        } else {
          nextId = 'step-completion';
        }
      } else if (currentId === 'step-6a' || currentId === 'step-6b') {
        nextId = 'step-completion';
      }
      
      showStep(nextId);
    }
    
    on(backBtn, 'click', function() {
      if (history.length > 0) {
        var prevId = history.pop();
        showStep(prevId);
      }
    });
    
    // Bind option clicks
    $$('.quiz-option').forEach(function(opt) {
      on(opt, 'click', function() {
        var isCheckbox = opt.getAttribute('role') === 'checkbox';
        var isChecked = opt.getAttribute('aria-checked') === 'true';
        
        if (isCheckbox) {
          opt.setAttribute('aria-checked', String(!isChecked));
          opt.classList.toggle('quiz-options__item-selected', !isChecked);
          var continueBtn = $('#btn-continue-' + opt.closest('.quiz-step').id.replace('step-', ''));
          if (continueBtn) {
            continueBtn.classList.add('visible');
          }
        } else {
          // Radio
          var group = opt.closest('.quiz-options__group');
          $$('.quiz-option', group).forEach(function(o) {
            o.setAttribute('aria-checked', 'false');
            o.classList.remove('quiz-options__item-selected');
          });
          opt.setAttribute('aria-checked', 'true');
          opt.classList.add('quiz-options__item-selected');
          
          var val = opt.dataset.value;
          var stepId = opt.closest('.quiz-step').id;
          setTimeout(function() {
            nextStep(stepId, val);
          }, 300);
        }
      });
    });
    
    var btn4a = $('#btn-continue-4a');
    if (btn4a) {
      on(btn4a, 'click', function() {
        nextStep('step-4a', null);
      });
    }
    
    showStep('step-1');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();